<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-group row">      
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtIpAdress"
              formControlName="IPAddress"
              #focusElement
              [Label]="'USER.IPADDRESS.SINGULAR'">
            </yt-input>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
